/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, spacing, font, zindex, breakpoints, ReduceMotion, animationDurationInMS, visuallyHiddenCss } from '@chegg-ui/theme';
import { Accordion } from '@chegg-ui/accordion';
import { Avatar } from '@chegg-ui/avatar';
import { IconButton } from '@chegg-ui/button';
import { Link } from '@chegg-ui/link';
import { SkipLink } from '@chegg-ui/skiplink';
import { Toggletip } from '@chegg-ui/toggletip';
import { Tooltip } from '@chegg-ui/tooltip';
import styled, { css, keyframes } from 'styled-components';
import { borderRadius } from './externals';
export var mobileHeaderHeightInPixels = 46;
export var desktopHeaderHeightInPixels = 60;
export var centerLinkPadding = 10;
export var compressedSearchWidth = '330px';
export var expandedSearchWidth = '630px';
export var mobileLinkHeightInPixels = 40;
export var HeaderContainer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-0"
})(["height:", "px;border-bottom:", ";box-sizing:content-box;position:fixed;width:100%;background-color:", ";z-index:350;font-family:", ";@media (max-width:", "){height:", "px;}"], desktopHeaderHeightInPixels, function (_ref) {
  var hideBorder = _ref.hideBorder;

  /* istanbul ignore next */
  return hideBorder ? 'none' : "".concat(spacing.px4, " solid ").concat(colors.cheggOrange);
}, colors.white, font.family["default"], breakpoints.md.max, mobileHeaderHeightInPixels);
export var Spacer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-1"
})(["height:", "px;@media (min-width:", "){height:", "px;}"], mobileHeaderHeightInPixels, breakpoints.lg.min, desktopHeaderHeightInPixels);
export var HeaderContent = styled.div.withConfig({
  componentId: "sc-1j1o3ml-2"
})(["max-width:1200px;height:100%;margin:0 auto;padding:0 ", ";display:flex;position:relative;font-family:", ";justify-content:space-between;align-items:center;"], spacing.px8, font.family["default"]);
export var MenuButton = styled(IconButton).withConfig({
  componentId: "sc-1j1o3ml-3"
})(["padding:0;&:hover{color:", ";transform:none;}", " & > svg{height:2.5rem;width:2.5rem;}"], colors.cheggOrange, function (props) {
  return props.isHidden ? 'visibility: hidden;' : '';
});
export var NavDropdown = styled.div.withConfig({
  componentId: "sc-1j1o3ml-4"
})(["position:absolute;display:", ";background-color:", ";border:1px solid ", ";border-radius:0 ", " ", ";top:", "px;left:0.25rem;"], function (props) {
  return props.isOpen ? 'block' : 'none';
}, colors.white, colors.greyLight, borderRadius.small, borderRadius.small, desktopHeaderHeightInPixels - 10);
export var NavDropdownCloseButton = styled(IconButton).withConfig({
  componentId: "sc-1j1o3ml-5"
})(["position:absolute;top:-", "px;left:-1px;padding-top:0;background-color:", ";border:1px solid ", ";border-bottom:none;border-radius:", " ", " 0 0;color:", ";&:hover{color:", ";transform:none;}& > svg{height:2.5rem;width:2.5rem;}"], desktopHeaderHeightInPixels * 0.75 + 1, colors.white, colors.greyLight, borderRadius.small, borderRadius.small, colors.cheggOrange, colors.cheggOrange);
export var MobileNavCloseButton = styled(IconButton).withConfig({
  componentId: "sc-1j1o3ml-6"
})(["position:absolute;color:", ";top:0;left:100%;background-color:", ";height:50px;width:44px;border:none;border-radius:0 0 ", ";&:hover{transform:none;}& > svg{height:2.5rem;width:2.5rem;top:50%;transform:translateY(-50%);position:absolute;left:0px;right:0px;margin:0px auto;}"], colors.cheggOrange, colors.white, borderRadius.small);
export var DropdownUL = styled.ul.withConfig({
  componentId: "sc-1j1o3ml-7"
})(["list-style:none;padding:0;margin:0;"]);
export var DropdownLI = styled.li.withConfig({
  componentId: "sc-1j1o3ml-8"
})(["display:flex;height:", ";"], spacing.px40);
export var NavDropdownLI = styled(DropdownLI).withConfig({
  componentId: "sc-1j1o3ml-9"
})(["height:3rem;width:250px;"]);
var activeMarkerCss = css(["font-weight:", ";&:before{content:'';background-color:", ";position:absolute;width:", ";height:", ";left:-1px;top:50%;transform:translateY(-50%);}"], font.weight.medium, colors.cheggOrange, spacing.px4, spacing.px24);
export var NavDropdownLink = styled(Link).withConfig({
  componentId: "sc-1j1o3ml-10"
})(["display:flex;min-width:11rem;width:100%;text-decoration:none;align-items:center;color:", ";position:relative;padding-left:", ";font-size:", ";font-weight:", ";", " &:link,&:visited,&:focus,&:hover,&:active{text-decoration:none;}&:visited{color:", ";}&:hover{font-family:", ";color:", ";", " & > svg{color:", ";}}& > svg{margin:0.5rem;", "}& > span{margin-left:", ";}"], colors.dark, spacing.px8, font.size.px16, font.weight.normal, function (props) {
  return props.isActive ? activeMarkerCss : '';
}, colors.dark, font.family["default"], colors.dark, activeMarkerCss, colors.cheggOrange, function (props) {
  return props.isActive ? "color: ".concat(colors.cheggOrange, ";") : '';
}, spacing.px8);
export var MobileNavOverlay = styled.div.withConfig({
  componentId: "sc-1j1o3ml-11"
})(["position:fixed;top:0;bottom:0;right:0;left:0;z-index:", ";background-color:rgba(0,0,0,0.3);pointer-events:", ";opacity:", ";transition:opacity 0.4s;@media (prefers-reduced-motion:reduce){transition:none;}"], zindex.layout, function (props) {
  return props.isOpen ? 'auto' : 'none';
}, function (props) {
  return props.isOpen ? 1 : 0;
});
export var MobileNavContent = styled.div.withConfig({
  componentId: "sc-1j1o3ml-12"
})(["background-color:", ";width:275px;position:fixed;top:0;bottom:0;z-index:", ";left:", ";transition:left 0.5s;color:", ";@media (prefers-reduced-motion:reduce){transition:none;}"], colors.white, zindex.layout, function (props) {
  return props.isOpen ? 0 : '-100%';
}, colors.dark); // scrollcontainer hides so that interactive descendents within can't be tabbed to

export var MobileNavScrollContainer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-13"
})(["height:100%;overflow-y:scroll;overflow-x:hidden;display:", ";scrollbar-width:none;-ms-overflow-style:none;&::-webkit-scrollbar{width:0;height:0;}"], function (props) {
  return props.isOpen ? 'block' : 'none';
});
export var LogoLink = styled.a.withConfig({
  componentId: "sc-1j1o3ml-14"
})(["color:", ";display:flex;margin-left:", ";margin-right:", ";text-decoration:none;margin-right:&:link,&:visited,&:hover,&:active{text-decoration:none;}& > svg{fill:", ";}@media (max-width:", "){margin-left:", ";}@media (max-width:", "){margin-right:auto;}"], colors.cheggOrange, spacing.px16, spacing.px4, colors.cheggOrange, breakpoints.sm.max, spacing.px8, breakpoints.md.max);
export var VisuallyHidden = styled.span.withConfig({
  componentId: "sc-1j1o3ml-15"
})(["", ""], visuallyHiddenCss);
export var CenterLinksUL = styled.ul.withConfig({
  componentId: "sc-1j1o3ml-16"
})(["display:flex;list-style:none;margin:0;padding:0;"]);
export var CenterLinks = styled.div.withConfig({
  componentId: "sc-1j1o3ml-17"
})(["display:flex;align-items:center;height:100%;"]);

var getTooltipStyleOverrides = function getTooltipStyleOverrides(position) {
  return css(["display:inline-flex;& > div{top:calc(100% + 1rem - 1px);background-color:", ";padding:", "rem ", "rem;", "}"], colors.white, 10 / 16, 20 / 16, function () {
    switch (position) {
      case 'bottom':
      case 'bottomRight':
      case 'bottomLeft':
        return "\n          &::before {\n            border-bottom-color: #dddddd;\n          }\n          &::after {\n            border-bottom-color: ".concat(colors.white, ";\n          }\n        ");
    }
  }());
};

export var StyledTooltip = styled(Tooltip).withConfig({
  componentId: "sc-1j1o3ml-18"
})(["", ""], function (_ref2) {
  var position = _ref2.position;
  return getTooltipStyleOverrides(position);
});
export var StyledToggletip = styled(Toggletip).withConfig({
  componentId: "sc-1j1o3ml-19"
})(["", " & > div{padding:0;}& a{font-size:", ";}"], function (_ref3) {
  var position = _ref3.position;
  return getTooltipStyleOverrides(position);
}, font.size.px14);
export var BlackStyledToggletip = styled(StyledToggletip).withConfig({
  componentId: "sc-1j1o3ml-20"
})(["margin-left:", ";& > div:last-child{&:before{border-bottom-color:#555555;background-color:#555555;}&:after{border-bottom-color:transparent;background-color:#555555;}}"], spacing.px12);
export var CenterLink = styled(Link).withConfig({
  componentId: "sc-1j1o3ml-21"
})(["text-decoration:none;color:", ";margin:auto;padding:0 ", "px;box-sizing:content-box;position:relative;font-family:", ";font-weight:", ";font-size:", ";white-space:nowrap;&:visited{color:", ";}&::before{", " display:block;position:absolute;width:calc(100% - ", "px);background-color:", ";content:'';transition:bottom 0.2s;@media (prefers-reduced-motion:reduce){transition:none;}}&:hover{text-decoration:none;&:before{height:5px;bottom:-4px;}}"], colors.dark, centerLinkPadding, font.family["default"], font.weight.bold, font.size.px16, colors.dark, function (props) {
  return props.isActive ? css(["height:5px;bottom:-4px;"]) : css(["height:0;bottom:-9px;"]);
}, 2 * centerLinkPadding, colors.cheggOrange);
export var CenterLinkNewLabel = styled.span.withConfig({
  componentId: "sc-1j1o3ml-22"
})(["font-family:", ";font-weight:", ";font-size:0.5rem;transform:translate(0%,-90%);"], font.family["default"], font.weight.bold);
export var CenterDropdownLink = styled(Link).withConfig({
  componentId: "sc-1j1o3ml-23"
})(["text-decoration:none;color:", ";margin:", ";display:block;white-space:nowrap;padding:", " 0;line-height:0;width:10rem;font-weight:", ";&:hover{font-weight:", ";text-decoration:none !important;color:black;}&:visited{color:", ";}"], colors.dark, spacing.px8, spacing.px16, font.weight.medium, font.weight.bold, colors.dark);
export var Divider = styled.div.withConfig({
  componentId: "sc-1j1o3ml-24"
})(["border-right:1px solid ", ";margin:0 ", ";"], colors.dark, spacing.px8);
export var MobileButtonsContainer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-25"
})(["display:flex;align-items:center;"]);
export var CartLink = styled(Link).withConfig({
  componentId: "sc-1j1o3ml-26"
})(["position:relative;color:", ";display:flex;margin-left:", ";@media only screen and (max-width:", "){margin:0;}&:visited{color:", ";}&:hover{color:", ";}"], colors.dark, spacing.px8, breakpoints.md.max, colors.dark, colors.cheggOrange);
export var SessionSpecificItems = styled.div.withConfig({
  componentId: "sc-1j1o3ml-27"
})(["display:flex;align-items:center;height:100%;"]);
export var CaretButton = styled(IconButton).withConfig({
  componentId: "sc-1j1o3ml-28"
})(["display:flex;align-items:center;padding:0;font-family:", ";font-weight:", ";font-size:", ";&::before{height:0;bottom:-9px;display:block;position:absolute;width:100%;background-color:", ";content:'';transition:bottom 0.2s;@media (prefers-reduced-motion:reduce){transition:none;}}&:hover{&[aria-label='more links']{&:before{height:5px;bottom:-4px;}}text-decoration:none !important;transform:none;*{text-decoration:none !important;}}& > svg{margin-left:", ";}", ""], font.family["default"], font.weight.bold, font.size.px14, colors.cheggOrange, spacing.px4, function (props) {
  return props['aria-expanded'] ? "\n    & > svg {\n      transform: rotate(180deg);\n    }\n  " : '';
});
export var UserDropdownInfo = styled.li.withConfig({
  componentId: "sc-1j1o3ml-29"
})(["background-color:#555555;border-radius:", " ", " 0 0;margin:-1px;width:300px;"], borderRadius.medium, borderRadius.medium);
export var UserDropdownInfoLink = styled.a.withConfig({
  componentId: "sc-1j1o3ml-30"
})(["display:flex;text-decoration:none;"]);
export var BorderedAvatar = styled(Avatar).withConfig({
  componentId: "sc-1j1o3ml-31"
})(["& > img{border:1px solid #dddddd;}& > span{display:none;}"]);
export var PaddedAvatar = styled(Avatar).withConfig({
  componentId: "sc-1j1o3ml-32"
})(["margin:1rem;"]);
export var SmallPaddedAvatar = styled(Avatar).withConfig({
  componentId: "sc-1j1o3ml-33"
})(["margin:calc(0.5rem - 1px);& > img{border:1px solid #dddddd;width:2.5rem;height:2.5rem;min-width:2.5rem;max-width:2.5rem;min-height:2.5rem;max-height:2.5rem;}"]);
export var UserDropdownTextContainer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-34"
})(["color:", ";position:relative;width:100%;"], colors.white);
export var UserInfo = styled.div.withConfig({
  componentId: "sc-1j1o3ml-35"
})(["width:100%;box-sizing:border-box;padding-right:2.5rem;position:absolute;top:50%;transform:translateY(-50%);"]);
export var UserName = styled.p.withConfig({
  componentId: "sc-1j1o3ml-36"
})(["margin:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:white;display:block;text-decoration:none;font-size:", ";font-weight:", ";"], font.size.px20, font.weight.normal);
export var UserEmail = styled.p.withConfig({
  componentId: "sc-1j1o3ml-37"
})(["font-size:", ";font-weight:", ";text-decoration:none;color:", ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:0;"], font.size.px12, font.weight.normal, colors.greyMedlight);
export var ThreeDots = styled.div.withConfig({
  componentId: "sc-1j1o3ml-38"
})(["transform:translateY(-50%) rotate(-90deg);position:absolute;right:10px;top:50%;"]);
export var SignInLink = styled(Link).withConfig({
  componentId: "sc-1j1o3ml-39"
})(["position:relative;color:", ";font-family:", ";font-weight:", ";font-size:", ";margin-left:", ";white-space:nowrap;&:visited{color:", ";}&::before{height:0;bottom:-9px;display:block;position:absolute;width:100%;background-color:", ";content:'';transition:bottom 0.2s;@media (prefers-reduced-motion:reduce){transition:none;}}&:hover{text-decoration:none;&:before{height:5px;bottom:-4px;}}"], colors.dark, font.family["default"], font.weight.bold, font.size.px14, spacing.px12, colors.dark, colors.cheggOrange);
export var CreateAccountLink = styled(SignInLink).withConfig({
  componentId: "sc-1j1o3ml-40"
})(["margin-left:0;"]);
var expandWidth = keyframes(["from{max-width:", ";}to{max-width:", ";}"], compressedSearchWidth, expandedSearchWidth);
export var LegacyHeaderSearchContainer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-41"
})(["width:100%;max-width:", ";", " ", ""], function (_ref4) {
  var searchActive = _ref4.searchActive;
  return searchActive ? expandedSearchWidth : compressedSearchWidth;
}, function (_ref5) {
  var searchActive = _ref5.searchActive;
  return !searchActive && 'margin-left: auto;';
}, function (_ref6) {
  var searchActivating = _ref6.searchActivating;
  return searchActivating ? css(["animation:", " ", "ms;", " & > form > div > div > div > ul{display:none;}"], expandWidth, animationDurationInMS.slower, ReduceMotion) : '';
});
export var CloseButton = styled(IconButton).withConfig({
  componentId: "sc-1j1o3ml-42"
})(["color:", ";margin-right:", ";&:hover{transform:none;}"], colors.cheggOrange, spacing.px16);
export var ResponsiveHeaderSearchContainer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-43"
})(["width:100%;max-width:1200px;margin:0 auto;padding:0 ", ";box-sizing:border-box;"], spacing.px8);
export var DesktopCoreNavGroup = styled.div.withConfig({
  componentId: "sc-1j1o3ml-44"
})(["display:flex;align-items:center;height:100%;"]);
export var NavLink = styled.a.withConfig({
  componentId: "sc-1j1o3ml-45"
})(["display:flex;align-items:center;text-decoration:none;height:", "px;font-size:1rem;flex-grow:1;&:link,&:visited,&:hover,&:active{text-decoration:none;}"], mobileLinkHeightInPixels);
var activeNavLinkCss = "\n  color: ".concat(colors.white, ";\n  background-color: ").concat(colors.cheggOrange, ";\n  border-radius: 0.25rem;\n");
export var TopLevelNavLink = styled(NavLink).withConfig({
  componentId: "sc-1j1o3ml-46"
})(["color:inherit;white-space:nowrap;"]);
export var HomeLink = styled(TopLevelNavLink).withConfig({
  componentId: "sc-1j1o3ml-47"
})(["margin:0 ", ";padding:0 ", ";border-bottom:1px solid ", ";", ""], spacing.px8, spacing.px8, colors.greyLight, function (_ref7) {
  var isActive = _ref7.isActive;
  return isActive ? activeNavLinkCss : "&:hover {\n        background-color: ".concat(colors.greyXlight, ";\n      }");
});
var navLinkMargin = '0.75rem';
export var SecondLevelNavLink = styled(NavLink).withConfig({
  componentId: "sc-1j1o3ml-48"
})(["color:", " !important;padding-left:calc(48px - ", ");"], function (props) {
  return props.isActive ? colors.cheggOrange : 'inherit';
}, navLinkMargin);
export var ThirdLevelNavLink = styled(NavLink).withConfig({
  componentId: "sc-1j1o3ml-49"
})(["padding-left:calc(66px - ", " - ", ");background-color:#e5e5e5;color:inherit;"], spacing.px8, navLinkMargin);
export var NavLinkText = styled.p.withConfig({
  componentId: "sc-1j1o3ml-50"
})(["font-family:", ";font-weight:", ";margin:0;margin-left:", ";"], font.family["default"], font.weight.medium, spacing.px12);
export var StyledAccordion = styled(Accordion).withConfig({
  componentId: "sc-1j1o3ml-51"
})(["box-sizing:border-box;padding:0 ", ";& > h2 > button{padding-left:", ";}", ""], spacing.px8, spacing.px8, function (_ref8) {
  var activeTabIndex = _ref8.activeTabIndex;
  return activeTabIndex >= 0 ? // we need the multiplication logic as there are `<div>` panel siblings between each `<h2>`
  "\n        & > h2:nth-child(".concat(activeTabIndex * 2 + 1, ") > button {\n          ").concat(activeNavLinkCss, "\n        }\n        & > div {\n          border-bottom: 0;\n        }\n      ") : '';
});
export var NestedAccordion = styled(Accordion).withConfig({
  componentId: "sc-1j1o3ml-52"
})(["& > h2 > button,& > h2 > button:hover{background-color:#eeeeee;padding-left:0;border:0;}"]);
export var LinkAccordionHeader = styled.div.withConfig({
  componentId: "sc-1j1o3ml-53"
})(["display:flex;width:100%;align-items:center;color:inherit;box-sizing:border-box;"]);
export var MobileAccordionDivider = styled.div.withConfig({
  componentId: "sc-1j1o3ml-54"
})(["background-color:", ";height:20px;width:0.0625rem;"], function (props) {
  return props.inverted ? colors.white : '#dddddd';
});
export var LinkAccordionPanel = styled.div.withConfig({
  componentId: "sc-1j1o3ml-55"
})(["background-color:#eeeeee;border-radius:0 0 ", " ", ";"], borderRadius.medium, borderRadius.medium);
export var UserInfoUL = styled.ul.withConfig({
  componentId: "sc-1j1o3ml-56"
})(["list-style:none;padding:1rem 0.5rem 10rem;margin:0;"]);
export var UserInfoLink = styled(Link).withConfig({
  componentId: "sc-1j1o3ml-57"
})(["display:flex;align-items:center;height:", ";padding-left:56px;font-family:", ";font-weight:", ";font-size:", ";font-weight:normal;color:", ";&:link,&:visited,&:hover,&:active{color:", ";}"], spacing.px40, font.family["default"], font.weight.medium, font.size.px14, colors.dark, colors.dark);
export var UserProfileLink = styled(UserInfoLink).withConfig({
  componentId: "sc-1j1o3ml-58"
})(["font-family:", ";height:", ";padding:0;"], font.family["default"], spacing.px40);
export var UserProfileText = styled.p.withConfig({
  componentId: "sc-1j1o3ml-59"
})(["padding:0;margin:0;font-size:1rem;line-height:1rem;"]);
export var UserEmailText = styled(UserProfileText).withConfig({
  componentId: "sc-1j1o3ml-60"
})(["font-size:", ";color:", ";"], font.size.px12, colors.grey);
export var MenuFooter = styled.div.withConfig({
  componentId: "sc-1j1o3ml-61"
})(["position:static;bottom:20px;width:100%;padding-bottom:90px;font-family:", ";"], font.family["default"]);
export var Copyright = styled.p.withConfig({
  componentId: "sc-1j1o3ml-62"
})(["margin:", " ", ";color:", ";font-size:", ";text-align:center;"], spacing.px12, spacing.px8, colors.grey, font.size.px12);
export var MenuFooterTerms = styled.div.withConfig({
  componentId: "sc-1j1o3ml-63"
})(["display:flex;justify-content:center;text-align:center;align-items:center;& > a{color:", ";font-size:", ";text-decoration:none;}"], colors.grey, font.size.px12);
export var UserTextContainer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-64"
})(["color:", ";position:relative;width:100%;"], colors.dark);
export var UserInfoLI = styled.li.withConfig({
  componentId: "sc-1j1o3ml-65"
})([""]);
export var HighZindexSkipLink = styled(SkipLink).withConfig({
  componentId: "sc-1j1o3ml-66"
})(["z-index:", ";"], zindex.sledgehammer);
export var DesktopUserMenuContainer = styled.div.withConfig({
  componentId: "sc-1j1o3ml-67"
})(["display:flex;"]);